// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5":"cdf9f94e","347":"cdf9f94e","512":"e341dc1e","923":"90848828"}[chunkId] + ".css";
};